import { z } from 'zod';

export const linkedInvoiceSchema = z.object({
    FromInvoice: z.number(),
    ToInvoice: z.number(),
    positionTitle: z.string().default(""),
    to_value_subtract: z.boolean().default(true)
})
export type ILinkedInvoice = z.infer<typeof linkedInvoiceSchema>;